import React, { useEffect, useMemo, useState } from 'react';
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

const ChildForm = ({ open, onClose, onSubmit, groupId, child }) => {
  const emptyForm = useMemo(
    () => ({
      name: '',
      primary_parent_email: '',
      secondary_parent_email: '',
      date_of_birth: '',
      group_id: groupId ?? '',
    }),
    [groupId]
  );

  const [formData, setFormData] = useState(emptyForm);

  useEffect(() => {
    if (child) {
      setFormData({
        name: child.name ?? '',
        primary_parent_email: child.primary_parent_email ?? '',
        secondary_parent_email: child.secondary_parent_email ?? '',
        date_of_birth: child.date_of_birth ?? '',
        group_id: child.group_id ?? groupId ?? '',
      });
      return;
    }
    setFormData(emptyForm);
  }, [child, emptyForm, groupId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    onSubmit(formData);
    onClose();
    if (!child) {
      setFormData(emptyForm);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{child ? 'Editează Copil' : 'Adaugă Copil'}</DialogTitle>
      <DialogContent>
        <TextField
          label="Nume"
          name="name"
          required
          fullWidth
          margin="normal"
          value={formData.name}
          onChange={handleChange}
        />
        <TextField
          label="E-mail Părinte Principal"
          name="primary_parent_email"
          type="email"
          required
          fullWidth
          margin="normal"
          value={formData.primary_parent_email}
          onChange={handleChange}
        />
        <TextField
          label="E-mail Părinte Secundar"
          name="secondary_parent_email"
          type="email"
          fullWidth
          margin="normal"
          value={formData.secondary_parent_email}
          onChange={handleChange}
        />
        <TextField
          label="Data Nașterii"
          name="date_of_birth"
          type="date"
          required
          fullWidth
          margin="normal"
          value={formData.date_of_birth}
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Anulează</Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          {child ? 'Salvează' : 'Adaugă'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChildForm;
